import styled from 'styled-components';
import HyperLink from 'components/Core/HyperLink';
import { STLogo } from 'components/Brand/Logos/STLogo';
import { Layout, Row, Col } from 'antd';
const { Footer } = Layout;

export const FooterWrapper = styled(Footer)`
  margin-bottom: -25px;
  padding-left: 28px !important;
  padding-right: 28px !important;

  @media (max-width: 768px) {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  background-color: var(--tertiary-color) !important;
`;

export const InnerContainer = styled.div`
  max-width: 1280px;
  margin: 0px auto;
  font-family: var(--font-family);

  @media (min-width: 1200px) {
    padding: 0 20px;
  }

  @media (max-width: 768px) {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const STFooterLogo = styled(STLogo)`
  margin-top: 40px;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    width: 178px;
    margin-top: 16px;
    margin-bottom: 28px;
  }
`;

export const FooterBody = styled(Row)`
  background: transparent;
  color: var(--neutral-text-color);
  padding-top: 20px;
  border: 0;

  .footer--mobile-menu-column {
    margin-bottom: 20px;
  }

  @media (min-width: 768px) {
    .ant-col {
      flex: 0 0 20%;
      max-width: 20%;
    }
  }

  @media (max-width: 992px) {
    .ant-col {
      padding-bottom: 30px;
    }
  }

  @media (max-width: 576px) {
    padding-top: 0px;
  }
`;

export const Title = styled.div`
  font-family: var(--font-family);
  font-size: var(--font-size-h5);
  color: var(--neutral-text-color);
  padding-bottom: 30px;
  font-weight: 900;
  line-height: 120%;
  letter-spacing: -0.02em;

  @media (max-width: 992px) {
    font-size: 20px;
    padding-bottom: 15px;
  }
  @media (max-width: 576px) {
    margin-top: 20px;
  }
`;

export const MenuItem = styled.a`
  color: white;
  display: block;
  font-size: var(--font-size-small);
  line-height: 100%;
  padding-bottom: 16px;
  font-weight: 500;

  &:hover {
    color: var(--disabled-text-color);
  }

  @media (max-width: 992px) {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    font-size: var(--font-size-small);
    line-height: 130%;
    padding-bottom: 15px;
  }
`;

export const MenuItemLink = styled(HyperLink)`
  color: white;
  display: block;
  font-size: var(--font-size-small);
  line-height: 100%;
  padding-bottom: 16px;
  font-weight: 500;

  &:hover {
    color: var(--disabled-text-color);
  }

  @media (max-width: 992px) {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    font-size: var(--font-size-small);
    line-height: 130%;
    padding-bottom: 15px;
  }
`;

export const Line = styled.div`
  margin-top: 56px;
  border-top: 1px solid var(--tertiary-hover-color);
  @media (max-width: 768px) {
    margin-top: 30px;
  }
`;

export const FooterBottom = styled.div`
  display: flex;
  margin-top: 24px;
  color: white;

  @media (max-width: 768px) {
    flex-flow: column;
    flex-direction: column-reverse;
    margin-top: 20px;
  }
`;

export const Copyright = styled.div`
  color: var(--neutral-text-color);
  margin-right: 15px;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    margin-top: 7px;
    margin-bottom: 0;
  }
`;

export const BottomItem = styled.a`
  margin-right: 20px;
  display: inline-block;
  color: var(--disabled-text-color);
  &:hover {
    color: var(--white-hover-color);
  }
`;

export const SocialIcons = styled.div`
  width: 16%;
  padding-top: 28px;
  align-items: baseline;
  display: flex;
  justify-content: flex-end;
  margin: auto;

  @media (max-width: 768px) {
    margin-bottom: 31px;
    padding-top: 0px;
    justify-content: unset;
    width: 100%;
    > a:first-child {
      padding-left: 0;
    }
  }
`;

export const IconItem = styled.a`
  padding-right: 20px;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const FooterBottomMenu = styled.div`
  display: flex;
  font-size: 13px;
  padding-top: 34px;
  width: 50%;
  padding-right: 30px;
  margin: auto;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    width: 100%;
    padding-right: 0px;
    padding-top: 0px;
    > div {
      width: 100%;
      display: flex;
      justify-content: space-between;
      > a {
        margin: 0;
      }
    }
  }
`;

export const FormContainer = styled.div`
  width: 34%;
  margin-top: -10px;
  @media (max-width: 768px) {
    width: 100%;
    > div {
      padding: 0;
    }
    margin-bottom: 30px;
  }
`;
